import React, { useState, useEffect, useContext } from 'react'
import { styled } from '@mui/material/styles'
import Layout from '@/product/components/templates/Layout'
// import ErpAuction from './ErpAuction'
// import Inventory from './Inventory'
import Orders from './Orders'
import Location from './Location'
import PropTypes from 'prop-types'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import './Schedule.css'
import { useHistory } from 'react-router-dom'
import OrderManager from './Orders/orderManage'
import { useLocation } from 'react-router-dom'
import ProductListView from '@/product/components/organisms/Product/ProductListView'
import AlertContext from '@/product/context/alert/alertContext'
import ScheduledPickupContext from '@/product/context/scheduledPickup/scheduledPickupContext'
import {
    handleRedirectInternal,
    dateTimeFormatFunction,
} from '@/product/common/components'
import Customer from './Customer'
import moment from 'moment'

const PREFIX = 'ERP'

const classes = {
    root: `${PREFIX}-root`,
}

const StyledLayout = styled(Layout)(({ theme }) => ({
    [`& .${classes.root}`]: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}))

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <div>{children}</div>}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const ERP = (props) => {
    const scheduledPickupContext = useContext(ScheduledPickupContext)
    const {
        getAllScheduledPickup,
        all_scheduled_pickup,
        schedulePickupAction,
        responseStatus,
        clearResponse,
    } = scheduledPickupContext
    const history = useHistory()
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const [value, setValue] = useState(1)
    const location = useLocation()
    const [events, setEvents] = useState([])
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        type: null,
    })

    let invId = props.match.params.id ? props.match.params.id : 0

    useEffect(() => {
        getAllScheduledPickup(
            {
                limit: 20,
                page: 1,
                orderby: '',
                order: '',
                filters: {
                    status: {
                        type: 'in',
                        value: '',
                        field: 'schedule_status',
                    },
                    name: {
                        type: 'like',
                        value: '',
                        field: 'name',
                    },
                    name: {
                        type: 'like',
                        value: '',
                        field: 'name',
                    },
                },
            },
            'calendarview'
        )
    }, [])

    const togglePopup = (popup, status, type) => {
        if (popup) {
            setManage({ popup, status, type })
        } else {
            setManage({ popup, status: 'new', type: null })
        }
    }

    useEffect(() => {
        if (all_scheduled_pickup) {
            if (
                all_scheduled_pickup.records &&
                all_scheduled_pickup.records.length
            ) {
                if (all_scheduled_pickup.from == 'calendarview') {
                    console.log(
                        all_scheduled_pickup.records,
                        'all_scheduled_pickup.records'
                    )
                    let records = all_scheduled_pickup.records.map((record) => {
                        return {
                            id: record.id,
                            title: `${moment(record.booking_start_date).format(
                                'hh:mm A'
                            )} - ${record.name}`,
                            start: record.booking_start_date,
                            end: record.booking_end_date,
                        }
                    })
                    console.log('records here ', records)

                    setEvents(records.length ? records : [])
                }
            }
        }
    }, [all_scheduled_pickup])

    const handleChange = (event, newValue) => {
        if (newValue === 0) {
            setValue(newValue)
        } else if (newValue === 1) {
            setValue(newValue)
        } else if (newValue === 2) {
            setValue(newValue)
        } else if (newValue === 3) {
            setValue(newValue)
        } else if (newValue === 4) {
            setValue(newValue)
        } else if (newValue === 5) {
            setValue(newValue)
        }
    }

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.status === 'success') {
                if (responseStatus.from == 'popupSubmit') {
                    setAlert('Successfully Added', responseStatus.status)
                    togglePopup(false, 'new', 'one')
                    getAllScheduledPickup(
                        {
                            limit: 20,
                            page: 1,
                            orderby: '',
                            order: '',
                            filters: {
                                status: {
                                    type: 'in',
                                    value: '',
                                    field: 'schedule_status',
                                },
                                name: {
                                    type: 'like',
                                    value: '',
                                    field: 'name',
                                },
                                name: {
                                    type: 'like',
                                    value: '',
                                    field: 'name',
                                },
                            },
                        },
                        'calendarview'
                    )
                }
            } else {
                setAlert(
                    responseStatus.message
                        ? responseStatus.message
                        : 'Internal server error',
                    'error'
                )
            }
            clearResponse()
        }
    }, [responseStatus])

    const customEventContent = (eventInfo) => {
        return <div className="cursorDecoy">{eventInfo.event.title}</div>
    }

    const handleEventClick = (info) => {
        const eventId = info.event.id
        console.log('eventId ', eventId)
        // props.function(true, 'edit', eventId)
    }

    const handleDateClick = (arg) => {
        togglePopup(true, 'new', 'one')
    }

    const submitPopupFunction = (values) => {
        let dateFields = ['booking_start_date', 'booking_end_date']
        let newObj = { ...values }
        dateFields.map((ele) => {
            newObj[ele] = moment(
                dateTimeFormatFunction(newObj[ele] ? newObj[ele] : new Date()),
                'MM-DD-YYYY h:mm a'
            ).format()
        })

        schedulePickupAction(newObj, 'popupSubmit')
    }

    return (
        <StyledLayout
            noUI={props.noUI || false}
            renderSidePanelDefault={props.renderSidePanelDefault || false}
        >
            {' '}
            <div className="">
                <AppBar position="static" className="scheduleTabs">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="fullWidth"
                        aria-label="ERP Tabs"
                    >
                        <Tab
                            className="dashIcon"
                            label={
                                <span className="material-icons">
                                    dashboard
                                </span>
                            }
                            {...a11yProps(0)}
                        />
                        <Tab label="Orders" {...a11yProps(1)} />
                        <Tab label="Schedule Calendar" {...a11yProps(2)} />
                        <Tab label="Message" {...a11yProps(3)} />
                        <Tab label="Customers" {...a11yProps(4)} />
                        <Tab label="Settings" {...a11yProps(5)} />
                    </Tabs>
                </AppBar>
                <TabPanel value={value} index={0}>
                    Dashboard
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Orders invId={invId} />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <div className="calendarAuctions">
                        <FullCalendar
                            plugins={[
                                dayGridPlugin,
                                timeGridPlugin,
                                interactionPlugin,
                            ]}
                            headerToolbar={{
                                left: 'prev,next today',
                                center: 'title',
                                right: 'dayGridMonth,timeGridWeek,timeGridDay',
                            }}
                            initialView="dayGridMonth"
                            editable={false}
                            selectable={true}
                            selectMirror={true}
                            dayMaxEvents={true}
                            initialEvents={events}
                            eventContent={customEventContent}
                            eventClick={handleEventClick}
                            dateClick={handleDateClick}
                        />
                    </div>
                </TabPanel>
                <TabPanel value={value} index={3}>
                    Messages
                </TabPanel>
                <TabPanel value={value} index={4}>
                    <Customer />
                </TabPanel>
                <TabPanel value={value} index={5}>
                    <Location />
                </TabPanel>
            </div>
            <OrderManager
                data={manage}
                function={togglePopup}
                submitFunction={submitPopupFunction}
            />
        </StyledLayout>
    )
}

export default ERP
